import {InjectionToken, Provider} from '@angular/core';
import {ActionReducerMap} from '@ngrx/store';
import {CustomCategoryActionTypes, CustomCategoryListActions} from '../actions/custom-category.action';
import {Category} from "@spartacus/core";
import {CustomCategoryState} from '../custom-category-state';

export const initialState: Category = {};

export const initialCategoryState: Category = {};

export function CategoryReducer(
  state = initialState,
  action: CustomCategoryListActions,
): Category {
  switch (action.type) {
    case CustomCategoryActionTypes.LOAD_CATEGORY_FAIL: {
      return initialState;
    }
    case CustomCategoryActionTypes.LOAD_CATEGORY_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
  }
  return state;
}

export function getCategoryReducers(): ActionReducerMap<CustomCategoryState> {
  return {
    category: CategoryReducer
  };
}

export const reducerCategoryToken: InjectionToken<ActionReducerMap<CustomCategoryState>> = new InjectionToken<ActionReducerMap<CustomCategoryState>>(
  'CategoryReducer',
);

export const reducerCategoryProvider: Provider = {
  provide: reducerCategoryToken,
  useFactory: getCategoryReducers,
};
